define(['jquery'], function ($) {

	var ERVTracking = function () {
		var self = this;

		self.$ervBody = $('#erv-body');

		self.createFunctionWithTimeout = function (callback, timeout) {
			var called = false;
			function fn() {
				if (!called) {
					called = true;

					if (typeof (callback) == 'function') {
						callback();
					}
				}
			}
			setTimeout(fn, timeout || 1000);
			return fn;
		};

		self.initCustomEvents = function () {
			$('body').on('click change', '*[data-customevent]', function (e) {
				var $this = $(this),
					eventName = $this.data('customevent'),
					category = $this.data('customeventcategory'),
					action = $this.data('customeventaction'),
					value = $this.data('customeventvalue');

				if (e.type !== eventName) {
					return;
				}

				if ($this.is('select') && typeof (value) === 'undefined') {
					value = $this.val();
				}

				self.trackEvent(category, action, value);
			});
		};

        self.initErrorHandling = function() {
			var self = this;
			window.onerror = function (msg, url, lineNo, columnNo, error) {
				var message = {
					'message': msg,
					'file': url ? url.split(/[\\/]/).pop() : url,
					'line': lineNo,
					'column': columnNo,
					'object': error
                },
				skip =	(message.file == 'fbevents.js' && $('body').hasClass('ie')) ||
						(message.file == 'conversion_async.js') || 
						(message.file.indexOf('aquant.js') > -1) || 
						(message.message.indexOf("meta[name='supported-color-schemes']") > -1) ||
						(message.file.indexOf('tp.widget') > -1) || // exclude Trustpilot error
						(message.file.indexOf('jsTag?ap=') > -1); // exclude adtraction errors


                if (!skip) {
					self.trackEvent('Exception', 'Error', JSON.stringify(message));
				}
				return true;
			};
		}
	};

	ERVTracking.prototype.hasGA = function () {
		return typeof (ga) !== 'undefined' && typeof (ga.getAll) === 'function' && ga.getAll().length;
	};

	ERVTracking.prototype.trackEvent = function (category, action, label, value, cb) {
		var self = this;
		if (self.hasGA()) {
			action = typeof (action) === 'undefined' ? 'Submit' : action;

			var tracker = ga.getAll()[0];

			tracker.send('event', category, action, label, value, {
				hitCallback: self.createFunctionWithTimeout(cb)
			});

		} else if (typeof (cb) === 'function') {
			cb();
		}
	};

	ERVTracking.prototype.init = function () {
		var self = this;
		self.initCustomEvents();

		//display js errors if dev/test/qa, js to analytics if production
		if (!window.ERV.ConfigurationSettings.IsDev) {
			self.initErrorHandling();
		}
	}

	return ERVTracking;
});